import { KeyboardEvent, RefObject, useCallback, useRef } from 'react'

import { IPopupMethods } from 'core-components/library/popup'

export const useOnInputKeyPress = () => {
  const popupActionsRef = useRef<IPopupMethods | null>(null)

  const setPopupActions = useCallback((selectPopupRef: RefObject<IPopupMethods | null>) => {
    if (selectPopupRef.current) {
      popupActionsRef.current = selectPopupRef.current
    }
  }, [])

  const onKeyPress = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      popupActionsRef.current?.open()
    }
  }, [])

  return { setPopupActions, onKeyPress }
}
